<template>
    <selector-popup
            ref="popup"
            header="Join Group"
            :items="items"
    >
        <template slot='descriptionTop'>
            <i>
                You have to be registered to join this Group.
            </i>
        </template>
        <template slot="footer">
            <button @click="back" type="button" class="btn btn-mm  btn-primary">Close</button>
        </template>
    </selector-popup>
</template>

<script>
    import SelectorPopup from "../../../../vue/common_components/SelectorPopup/SelectorPopup";

    export default {
        name: "LoginOrRequestInvitePopup",
        components: {SelectorPopup},
        computed: {
            items() {
                const items = [];
                items.push({
                    label: 'Log<br>in',
                    iconClass: 'fa-sign-in',
                    action: 'select',
                    selection: 'login',
                });
                items.push({
                    label: 'Request<br>Invite',
                    iconClass: 'fa-envelope-open-text',
                    action: 'select',
                    selection: 'request_invite',
                });
                return items;
            }
        },
        methods: {
            show() {
                return new Promise((resolve, reject) => {
                    this.reject = reject;
                    this.$refs.popup.show()
                        .then(item => {
                            if (item.action === 'select') {
                                resolve(item.selection);
                            }
                        }, reason => {
                            reject(reason);
                        });
                });
            },
            back() {
                this.reject('back');
            }
        }
    };
</script>